import React from 'react';
import { Redirect } from 'react-router-dom';

export default () => {
    localStorage.setItem('faasSubmitted', true)
    let persona = sessionStorage.getItem('desiredPersona')    
    return <Redirect to={persona ? `/${persona}/02` : '/'} />
}
